var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgSpaceId(props) {
  var _id6 = useUniqueInlineId();
  var _id5 = useUniqueInlineId();
  var _id4 = useUniqueInlineId();
  var _id3 = useUniqueInlineId();
  var _id2 = useUniqueInlineId();
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 118,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#".concat(_id, ")")
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#".concat(_id2, ")")
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.787 50.291c4.452-16.303-4.797-33.228-20.658-37.805-15.86-4.576-32.328 4.93-36.78 21.233-4.452 16.303 4.796 33.229 20.657 37.805 15.861 4.576 32.329-4.93 36.78-21.233z",
    fill: "#1EEFA4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.164 48.995c.408-1.493 1.884-2.372 3.297-1.964l1.023.295c1.413.407 2.228 1.948 1.82 3.44l-.295 1.08c-.408 1.493-1.883 2.373-3.296 1.965l-1.023-.295c-1.413-.408-2.228-1.948-1.82-3.44l.294-1.081zM49.117 37.301c-1.413-.408-2.889.472-3.296 1.964l-.295 1.08c-.408 1.493.407 3.034 1.82 3.441l1.023.295c1.413.408 2.889-.471 3.296-1.964l.295-1.08c.408-1.493-.407-3.033-1.82-3.44l-1.023-.296z",
    fill: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.448 22.557c-5.652-1.63-11.555 1.887-13.185 7.856l-3.69 13.51c-1.63 5.97 1.63 12.13 7.282 13.761l12.79 3.69c5.652 1.631 11.555-1.886 13.185-7.855l3.69-13.511c1.63-5.97-1.63-12.13-7.281-13.76l-12.791-3.691zm11.61 8.014l-12.791-3.69c-3.39-.98-6.933 1.131-7.91 4.713l-3.69 13.51c-.979 3.582.977 7.278 4.368 8.257l12.791 3.69c3.391.978 6.933-1.132 7.911-4.714l3.69-13.51c.978-3.581-.978-7.278-4.369-8.256z",
    fill: "#000"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#".concat(_id3, ")")
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#".concat(_id4, ")"),
    opacity: 0.3
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.695 108.449c-4.529-9.03-15.322-12.579-24.108-7.924-8.787 4.654-12.238 15.748-7.71 24.779s15.321 12.579 24.108 7.924c8.786-4.654 12.238-15.748 7.71-24.779z",
    fill: "#1EEFA4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.047 119.486c-.414-.827-.116-1.833.667-2.248l.567-.3c.782-.415 1.753-.081 2.168.746l.3.599c.414.826.116 1.833-.667 2.247l-.567.3c-.782.415-1.753.081-2.167-.746l-.3-.598zM28.01 111.849c-.782.414-1.08 1.42-.666 2.247l.3.599c.415.827 1.386 1.161 2.168.746l.567-.3c.783-.415 1.081-1.421.667-2.248l-.3-.598c-.415-.827-1.386-1.161-2.168-.747l-.567.301z",
    fill: "#000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.34 109.015c-3.13 1.658-4.324 5.683-2.666 8.99l3.753 7.484c1.658 3.307 5.54 4.643 8.67 2.985l7.086-3.754c3.13-1.658 4.324-5.683 2.666-8.99l-3.752-7.484c-1.659-3.306-5.54-4.643-8.671-2.984l-7.086 3.753zm8.287-1.358l-7.086 3.753c-1.878.995-2.594 3.41-1.6 5.394l3.753 7.484c.995 1.984 3.324 2.786 5.202 1.791l7.086-3.754c1.878-.995 2.595-3.41 1.6-5.394l-3.753-7.484c-.995-1.984-3.324-2.785-5.202-1.79z",
    fill: "#000"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#".concat(_id5, ")")
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#".concat(_id6, ")"),
    opacity: 0.6
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M98.718 99.198c2.98-6.041.631-13.421-5.246-16.484-5.877-3.063-13.058-.65-16.038 5.392-2.98 6.041-.63 13.421 5.247 16.484 5.877 3.063 13.057.649 16.037-5.392z",
    fill: "#1EEFA4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M87.979 96.482c.272-.553.918-.78 1.442-.507l.379.197c.523.273.727.943.454 1.496l-.198.4c-.272.553-.918.78-1.442.507l-.379-.197c-.523-.273-.727-.942-.454-1.496l.198-.4zM91.198 92.37c-.524-.274-1.17-.047-1.442.506l-.198.401c-.272.553-.069 1.222.455 1.495l.379.198c.523.273 1.169.046 1.442-.507l.197-.4c.273-.554.07-1.223-.454-1.496l-.379-.198z",
    fill: "#000"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.91 85.891c-2.093-1.091-4.675-.183-5.766 2.03l-2.47 5.006c-1.091 2.212-.278 4.89 1.816 5.98l4.74 2.471c2.094 1.091 4.676.183 5.767-2.03l2.47-5.005c1.091-2.213.278-4.89-1.816-5.982l-4.74-2.47zm3.95 4.072l-4.74-2.47c-1.256-.654-2.805-.11-3.46 1.218l-2.47 5.006c-.654 1.327-.166 2.934 1.09 3.589l4.74 2.47c1.257.655 2.806.11 3.46-1.218l2.47-5.006c.655-1.327.167-2.934-1.09-3.589z",
    fill: "#000"
  })))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _id
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "matrix(.96081 .2772 -.26345 .96467 19.115 0)",
    d: "M0 0h66.423v67.999H0z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: _id2
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "matrix(.96081 .2772 -.26345 .96467 21.41 4.2)",
    d: "M0 0h59.781v61.199H0z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: _id3
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "matrix(.88367 -.4681 .44822 .89392 0 108.071)",
    d: "M0 0h40.007v40.65H0z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: _id4
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "matrix(.88367 -.4681 .44822 .89392 2.678 108.952)",
    d: "M0 0h36.006v36.585H0z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: _id5
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "matrix(.8868 .46215 -.44239 .89682 82.248 75.336)",
    d: "M0 0h26.667v27.104H0z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: _id6
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "matrix(.8868 .46215 -.44239 .89682 82.83 77.168)",
    d: "M0 0h24.001v24.393H0z"
  })))));
}
export default SvgSpaceId;